<template>
  <div class="market-couponCenterPlatform-ccr-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch">
    </Search>
    <div class="fun-btn-box">
    </div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    > 
      <template #postRefId="{ row }">{{ row.postRefId|| '---' }}</template>
      <template #refId="{ row }">{{ row.refId|| '---' }}</template>
      <template #postRefName="{ row }">{{ row.postRefName|| '---' }}</template>
      <template #mallName="{ row }">{{ row.mallName|| '---' }}</template>
      <template #channel="{ row }">{{ row.channel|| '---'}}</template>
      <template #couponfName="{ row }">{{ row.couponfName|| '---' }}</template>
      <template #CashCoupon="{ row }">{{ onCouponeType(row.CashCoupon)}}</template>
      <template #validTime="{ row }">{{ row.validTime|| '---'}}</template>
      <template #discountInfo="{ row }">{{ row.discountInfo|| '---'}}</template>
      <template #threshold="{ row }">{{ row.threshold|| '---'}}</template>
      <template #description="{ row }">{{ row.description|| '---' }}</template>
      <template #stores="{ row }">
        <el-button v-if="row.stores" type="text" @click="onLookStore(row)">查看使用范围</el-button>
        <span v-else>---</span>
      </template>
      <template #description="{ row }">
        <el-button v-if="row.description" type="text" @click="onLookRemark(row)">查看使用须知</el-button>
        <span v-else>---</span>
      </template>
      <template #quantity="{ row }">{{ String(row.quantity) || '---'}}</template>
      <template #remain="{ row }">{{ String(row.remain)|| '---'}}</template>
      <template #created="{ row }">{{ row.created ? $moment(row.created).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
    </Table>
     <el-dialog :visible="isShowStoreDialog" title="使用范围" :before-close="() => this.isShowStoreDialog = false" width="30%">
      <div  class="storeDialog">
        <div v-for="(item,index) in currentRow" :key="index">{{ item.name }}</div>
      </div>
    </el-dialog>
    <el-dialog :visible="isShowRemarkDialog" title="使用须知" :before-close="() => this.isShowRemarkDialog = false" width="30%">
      <div class="remark-box" v-html="currentRowRemark.description"></div>
    </el-dialog>
    
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList'
import { api_getCouponeCenterList} from '@/api/market'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
export default {
  name: "mCuponCenterPlatformIndex",
  mixins: [ tableList ],
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    return {
      renderData: [
        {
          label: "券名称",
          placeholder: "请选择优惠券名称",
          type: "input",
          key: "couponName",
        },
        {
          label: "渠道来源",
          placeholder: "请输入渠道来源",
          type: "input",
          key: "channel",
        },
        {
          label: "商场名称",
          placeholder: "请输入商场名称",
          type: "input",
          key: "mallName",
        },
        {
          label: "外部批次号",
          placeholder: "请输入外部批次号",
          type: "input",
          key: "postRefId",
        },
        {
          label: "批次名称",
          placeholder: "请输入批次名称",
          type: "input",
          key: "name",
        },
        {
          label: "投放时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "time",
          valueFormat: 'timestamp'
        },
      ],
      form: {},
      isShowStoreDialog: false,
      isShowRemarkDialog:false,
      currentRow:[],
      currentRowRemark:'',
      tableThData: [
        { prop: "postRefId", label: "外部批次号", minWidth: "180", },
        { prop: "refId", label: "内部批次号", minWidth: "180", },
        { prop: "postRefName", label: "批次名称", minWidth: "180", },
        { prop: "mallName", label: "商场名称", minWidth: "180", },
        { prop: "channel", label: "渠道来源", minWidth: "180", },
        { prop: "couponfName", label: "优惠券名称", minWidth: "160", },
        { prop: "CashCoupon", label: "券类型", minWidth: "160", },
        { prop: "discountInfo", label: "券优惠", minWidth: "200", },
        { prop: "threshold", label: "券门槛", minWidth: "200", },
        { prop: "validTime", label: "有效期", minWidth: "200", },
        { prop: "stores", label: "使用范围", minWidth: "200", },
        { prop: "description", label: "使用须知", minWidth: "200", },
        { prop: "quantity", label: "总库存", minWidth: "200", },
        { prop: "remain", label: "可投放数量", minWidth: "200", },
        { prop: "created", label: "投放时间", minWidth: "200", },
      ],

    };
  },
  created () {
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      let params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      params.startTime = this.form.time ? this.form.time[0] : ''
      params.endTime = this.form.time ? this.form.time[1] : ''
      delete params.time
      const data = await api_getCouponeCenterList(params)
      console.log('data: ', data);
      data.resultList.map(item=>{
        item.postRefName = item.name
        item.couponfName = item.coupon.name
        item.CashCoupon = item.coupon.type
        item.validTime = item.coupon.validTime
        item.discountInfo = item.coupon.discountInfo
        item.threshold = item.coupon.threshold
        item.description = item.coupon.description
        item.stores = item.coupon.stores
      })
      this.tableTrData = data.resultList || []
      this.total = data.totalCount
      this.loading = false
    },
    onCouponeType(type){
      switch (type) {
        case 'CashCoupon':
          return '代金劵'
        case 'PercentOff':
          return '折扣券'
        default:
          return '---'
      }
    },
    onLookStore(row) {
      this.currentRow = row.stores
      this.isShowStoreDialog = true
    },
    // 查看使用须知
    onLookRemark(row) {
      this.currentRowRemark = row
      this.isShowRemarkDialog = true
    },
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-couponCenterPlatform-ccr-index {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;
  .storeDialog{
    width: 100%;
    height: 300px;
    text-align: center;
    overflow-y: auto;
  }
  .remark-box {
    width: 100%;
    min-height: 300px;
    max-height: 500px;
    overflow: auto;

    &::v-deep img {
      width: 100% !important;
    }
  }
}
</style>
